var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.349609 2.27342C0.349609 1.07286 1.32286 0.0996094 2.52342 0.0996094H13.4758C14.6764 0.0996094 15.6496 1.07286 15.6496 2.27342V9.7258C15.6496 10.9264 14.6764 11.8996 13.4758 11.8996H2.52342C1.32286 11.8996 0.349609 10.9264 0.349609 9.7258V2.27342ZM2.52342 1.39961C2.04083 1.39961 1.64961 1.79083 1.64961 2.27342V9.7258C1.64961 10.2084 2.04083 10.5996 2.52342 10.5996H13.4758C13.9584 10.5996 14.3496 10.2084 14.3496 9.7258V2.27342C14.3496 1.79083 13.9584 1.39961 13.4758 1.39961H2.52342Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72461 2.72461H11.2746V4.89961H9.97461V4.02461H8.64961V7.97461H10.3996V9.27461H5.59961V7.97461H7.34961V4.02461H6.02461V4.89961H4.72461V2.72461Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcon);
export default __webpack_public_path__ + "static/media/input-icon.41478586acb7152fb9b742307b2f4f63.svg";
export { ForwardRef as ReactComponent };